import { fromJS } from 'immutable';
import * as constants from './constants';

//初始化数据
const defaultState = fromJS({
    versionInfo: {},  //版本信息
    linkStatus: {},  //链接状态
    portInfo: {},  //端口信息

    meterData: [],  //电表配置数据
    taskData: [],  //任务配置数据
    timeData: [],  //任务配置数据
    protocol:[],//通讯协议
    connectionMethod:[],//连接方式
    productList:[],//产品类型列表
});

// eslint-disable-next-line import/no-anonymous-default-export
export default (state = defaultState, action) => {
    switch (action.type) {
        case constants.TERMINAL_VERSION:
            return state.set('versionInfo', action.data);

        case constants.TERMINAL_LINK_STATUS:
            return state.set('linkStatus', action.data);

        case constants.TERMINAL_PORT:
            return state.set('portInfo', action.data);

        case constants.METER_DATA:
            return state.set('meterData', action.data);

        case constants.TASK_DATA:
            return state.set('taskData', action.data);

        case constants.TIME_DATA:
            return state.set('timeData', action.data);

        case constants.protocol:
            return state.set('protocol', action.data);

        case constants.connectionMethod:
            return state.set('connectionMethod', action.data);

        case constants.productList:
            return state.set('productList', action.data);


        default:
            return state;
    }
};
